export default __webpack_public_path__ + "static/media/b-9.225bf4dc.png";